import { pgTable, uuid, text, numeric, primaryKey } from "drizzle-orm/pg-core";
import { products } from "./products.js";
import { priceLists } from "./price-lists.js";

export const productPrices = pgTable(
  "product_prices",
  {
    productId: uuid("product_id")
      .notNull()
      .references(() => products.id, { onDelete: "cascade" }),
    priceListId: uuid("price_list_id")
      .notNull()
      .references(() => priceLists.id, { onDelete: "cascade" }),
    amount: numeric("amount", { precision: 12, scale: 2 }).notNull(),
    currency: text("currency").notNull().default("EUR"),
  },
  (t) => ({
    pk: primaryKey({ columns: [t.productId, t.priceListId] }),
  })
);

export type ProductPrice = typeof productPrices.$inferSelect;
export type NewProductPrice = typeof productPrices.$inferInsert;
